import React, { useEffect, useState } from "react";
// import moment from "moment-timezone";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePickup.css";

function DatePickup({
  filterDate,
  handleDateChange,
  showDefaultDate = true,
  disabled = false,
  dateplaceholder = "Choose Date",
}) {
  const today = moment().toDate();
  const [selectedDate, setSelectedDate] = useState(today);
  const [showDefault, setShowDefault] = useState(showDefaultDate);

  useEffect(() => {
    // const getDate = moment(filterDate).tz("America/New_York").toDate();
    const getDate = moment(filterDate).toDate();
    console.log(getDate, "getDate");
    // console.log(getDate, "getDate");
    setSelectedDate(getDate);
    setShowDefault(getDate != 'Invalid Date' ? true : false);
  }, [filterDate]);

  const onDateChange = (date) => {
    console.log(date, "chnageDateCheck");
    if (date) {
      setSelectedDate(date);
    //   const formattedDate = moment(date).toDate();
      handleDateChange(date);
    }
  };

  return (
    <div className="w-100">
      <DatePicker
        selected={showDefault ? selectedDate : null}
        onChange={onDateChange}
        // dateFormat="MM/dd/yyyy"
        dateFormat="dd/MM/yyyy"
        placeholderText={dateplaceholder}
        className="form-control form-control-sm datetimepicker w-100"
        wrapperClassName="w-100"
        disabled={disabled}
      />
    </div>
  );
}

export default DatePickup;
